<template>
  <SsoButton
    buttonText="Sign up with Google"
    imageUrl="sso_icon.svg"
    @ssoButtonClicked="handleGoogleSignIn"
  ></SsoButton>
</template>

<script>
  import loginSsoService from '../../services/LoginSsoService';
  import SsoButton from '../guest/SsoButton.vue';
  import { REGISTER_MUTATION } from '../../constants/graphql/authentication';

  export default {
    name: 'GoogleSsoSignUp',
    props: {
      acceptedTerms: {
        required: true,
        default: false,
        type: Boolean,
      },
      submitClicked: {
        required: false,
        default: false,
        type: Number,
      },
    },
    watch: {
      submitClicked() {
        this.signUp();
      },
    },
    components: {
      SsoButton,
    },
    methods: {
      signUp() {
        dataLayer.push({
          event: 'signupwithgooglebtn',
          omuserid: 'systemuserid',
        });

        if (this.acceptedTerms) {
          if (this.gisLoaded) {
            const client = google.accounts.oauth2.initTokenClient({
              client_id: this.whitelabel.sso.googleClientId,
              scope:
                'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/user.phonenumbers.read',
              callback: this.handleCredentialResponse,
            });

            client.requestAccessToken();
          } else {
            console.error(
              'Google Identity Services library is not loaded yet.'
            );
          }
        } else {
          this.$emit('onError');
        }
      },
      handleGoogleSignIn() {
        this.$emit('ssoButtonClicked');
      },
      handleCredentialResponse(response) {
        this.authenticate(response.access_token);
      },
      authenticate(token) {
        const referralCode =
          this.$cookies.get('referralCode') || this.$route.params.id;
        const omtId = this.$store.getters.omtId;
        const adReferrer = this.$store.getters.adReferrer;
        const fullReferrer = this.$store.getters.fullReferrer;

        this.$apollo
          .mutate({
            mutation: REGISTER_MUTATION,
            variables: {
              email: null,
              phone: null,
              uniqueIdentifier: null,
              password: null,
              acceptedTerms: this.acceptedTerms,
              referralCode,
              willCountry: 'ZA',
              acceptedCompetitionTerms: null,
              testatorCompetitionReferralId: null,
              omtId,
              adReferrer,
              fullReferrer,
              signupMethod: `Google SSO`,
              ssoToken: token,
            },
          })
          .then(result => {
            if (result.message?.includes('GraphQL error')) {
              throw result;
            }
            const testatorId = result?.data?.registerTestator?.testatorId;
            const testatorEmail = result?.data?.registerTestator?.email;
            dataLayer.push({
              event: 'signedupwithgoogle',
              omuserid: testatorId,
              emailaddress: testatorEmail,
            });
            loginSsoService.loginSuccess(
              result.data.registerTestator,
              this.$router,
              this.$cookies,
              this.$store
            );
          })
          .catch(error => {
            this.$emit('onError', error);
          });
      },
      loadGoogleLibrary() {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://accounts.google.com/gsi/client';
          script.async = true;
          script.defer = true;
          script.onload = () => resolve();
          script.onerror = () => reject();
          document.head.appendChild(script);
        });
      },
    },
    data() {
      return {
        gisLoaded: false,
      };
    },
    mounted() {
      this.loadGoogleLibrary()
        .then(() => {
          this.gisLoaded = true;
          google.accounts.id.initialize({
            client_id: this.whitelabel.sso.googleClientId,
            callback: this.handleCredentialResponse,
          });
        })
        .catch(() => {
          console.error('Failed to load Google Identity Services library.');
        });
    },
  };
</script>
